module.exports = __webpack_public_path__ + "img/tft-default.45ef9efd.png";